<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AuthLayout from '@/layouts/AuthLayout.vue'
import LoginForm from '@/components/auth/LoginForm.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import { getErrorMessage } from '@/utils/errorHandling'

const authStore = useAuthStore()
const router = useRouter()
const error = ref<string | null>(null)
const isLoading = ref(false)

const handleLogin = async (credentials: { email: string; password: string }) => {
  isLoading.value = true
  try {
    const role = await authStore.login(credentials.email, credentials.password)
    router.push(`/${role.toLowerCase()}`)
  } catch (err: unknown) {
    error.value = getErrorMessage(err, 'Invalid email or password')
    setTimeout(() => (error.value = null), 5000)
    isLoading.value = false
  }
}
</script>

<template>
  <LoadingSpinner v-if="isLoading" message="Signing in..." />
  <AuthLayout>
    <template #header>
      <h1 class="text-3xl font-bold text-gray-900">Welcome back</h1>
      <p class="mt-2 text-gray-600">
        Sign in to access your dashboard
      </p>
    </template>

    <div class="mt-8">
      <div
        v-if="error"
        class="mb-4 p-4 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm"
      >
        {{ error }}
      </div>

      <LoginForm @submit="handleLogin" />
    </div>
  </AuthLayout>
</template>
